
const el = {
  root: document.querySelector<HTMLButtonElement>('.product-list-navigation'),
  list: document.querySelector<HTMLUListElement>('.product-list-navigation__list'),
  indicator: document.querySelector<HTMLButtonElement>('.product-list-navigation__indicator'),
  items: document.querySelectorAll<HTMLLIElement>('.product-list-navigation__item '),
}

export const ProductListNavigation = {

  init: () => {
    if (!el.root || !el.list || !el.indicator) return
    ProductListNavigation.checkIfContentOverflows()
    el.indicator.addEventListener('click', ProductListNavigation.onIndicatorClick)
    el.list.addEventListener('scroll', ProductListNavigation.onScroll)
    window.addEventListener('resize', () => {
      ProductListNavigation.checkIfContentOverflows()
      ProductListNavigation.onScroll()
    })
  },

  checkIfContentOverflows: () => {
    const isOverflowing = el.list.scrollWidth > el.list.clientWidth;

    if (!isOverflowing) {
      el.root.classList.remove('product-list-navigation--with-indicator')
      return
    }

    el.root.classList.add('product-list-navigation--with-indicator')
  },
  
  onIndicatorClick: () => {
    const { scrollWidth, clientWidth, scrollLeft } = el.list

    const items = Array.from(el.items)
    const nextItem = items.find((item, i) => {
      const { offsetLeft, offsetWidth } = item
      return (offsetLeft + offsetWidth) >= (scrollLeft + clientWidth)
    })

    if (!nextItem) {
      el.list.scrollTo(scrollWidth, 0)
      return 
    }

    el.list.scrollTo(nextItem.offsetLeft - 20, 0)
  },

  onScroll: () => {
    const { scrollLeft, scrollWidth, clientWidth } = el.list
    const isFullyScrolled = (scrollLeft + clientWidth) >= scrollWidth
    const isButtonDisabled = el.indicator.disabled
    
    if (isFullyScrolled && !isButtonDisabled) {
      el.root.classList.add('product-list-navigation--fully-scrolled')
      el.indicator.disabled = true
      return
    }

    if (!isFullyScrolled && isButtonDisabled) {
      el.root.classList.remove('product-list-navigation--fully-scrolled')
      el.indicator.disabled = false
    }
  }
}